<template>

    <div>
        <!---------------------------------------------------项目信息-------------------------------------------------------------------->
        <div class="h-piece">
            <div class="h-pieceIn2 n-xiao" v-if="order.orderProjectCode && !showService && order.category1Name != '工程订单'">
                <div class="h-pieceTitle2 " style="margin-left:10px">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="order" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-input v-model="order.orderProjectName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目版本号" class="h-elformWrap-2">
                                <el-input v-model="order.orderProjectCode" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目合同编号" class="h-elformWrap-2">
                                <el-input v-model="order.orderSubContract" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------项目信息-------------------------------------------------------------------->
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                <el-input v-model="order.orderProjectName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目版本号" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                <el-input v-model="order.orderProjectCode" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目备注" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                <el-input v-model="order.projectDescription" readonly :title="order.projectDescription"></el-input>
                            </el-form-item>
                            <el-form-item label="订单类型" class="h-elformWrap-2">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <el-input v-model="xszzStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建人" class="h-elformWrap-2">
                                <el-input v-model="this.order.cuname" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                <el-input v-model="this.order.cdate" readonly></el-input>
                            </el-form-item>
                            <!--<el-form-item label="成本中心" class="h-elformWrap-2" v-if="showIsFree">-->
                            <!--<el-select v-model="order.costCenter" style="width: 100%;" disabled>-->
                            <!--<el-option v-for="item in costList" :key="item.index"-->
                            <!--:label="`${item.costCenterCode} : ${item.remark}`"-->
                            <!--:value="item.costCenterCode"></el-option>-->
                            <!--</el-select>-->
                            <!--</el-form-item>-->
                            <el-form-item label="订购原因" class="h-elformWrap-2" v-if="showIsFree">
                                <brselect clearable category="business_reason" :v="order.businessReason"
                                          v-model="order.businessReason" disabled></brselect>
                            </el-form-item>
                            <el-form-item label="增值税登记号" class="h-elformWrap-2" v-if="aflag">
                                <el-input v-model="this.order.vatNo" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="税号1" class="h-elformWrap-2" v-if="aflag">
                                <el-input v-model="this.order.taxNo" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="数据线" class="h-elformWrap-2" v-if="aflag">
                                <el-input v-model="this.order.dataWire" readonly></el-input>
                            </el-form-item>

                            <el-form-item label="样品机合同" class="h-elformWrap-2" v-if="showSampleHetong">
                                <brupload
                                        :refid=this.order.id
                                        reftype="样品机合同"
                                        :limit="1"
                                        :showtime="false"
                                        :uploadflag="false"
                                        :delflag="false"
                                >
                                </brupload>
                            </el-form-item>
                            <!--
                            <el-form-item label="备注" class="h-elformWrap-2">
                                <el-input v-model="this.order.note" readonly></el-input>
                            </el-form-item>
                            -->
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>客户信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form1" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item prop="soldToName" label="售达方名称"
                                          class="h-elformWrap-2">
                                <el-input v-model="order.soldToName" readonly/>
                            </el-form-item>

                            <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2"
                                          v-if="!showService">
                                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item label="送达方区域" class="h-elformWrap-2">
                                <el-input v-model="order.salesregionName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item prop="customerChannelCode" label="客户渠道" class="h-elformWrap-2">
                                <brselect
                                        :disabled="true"
                                        category="sales_region" :v="order.customerChannelCode"
                                        v-model="order.customerChannelCode"></brselect>
                            </el-form-item>

                         <el-form-item prop="isStockUp" label="是否备货" class="h-elformWrap-2"
                                          v-if="!showIsFree&&!showService">
                                <brselect category="shifou_keyong" disabled :v="order.isStockUp"
                                          v-model="order.isStockUp"></brselect>
                            </el-form-item>
                            <el-form-item prop="toCompanyname" label="收货单位" class="h-elformWrap-2">
                                <!--                            <el-form-item prop="toCompanyname" label="收货单位" class="h-elformWrap-2" v-if="!showService">-->
                                <el-input v-model="order.toCompanyname" :class="{'addredclass':regionaddflag}" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="收货地址" prop="toAddress" class="h-elformWrap-2">
                                <!--                                <el-form-item label="收货地址" prop="toAddress" class="h-elformWrap-2"-->
                                <!--                                              v-if="!showService">-->
                                <el-input  v-model="order.toAddress" :title="order.toAddress" readonly>
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="contactName" label="收货联系人" class="h-elformWrap-2">
                                <el-input v-model="order.contactName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话" class="h-elformWrap-2" prop="firsttelephone">
                                <div class="block">
                                    <el-input v-model="order.firsttelephone" readonly
                                    ></el-input>
                                </div>
                            </el-form-item>
                         <!-- <el-form-item label="提货联系人" class="h-elformWrap-2" prop="deliveryContactPerson">
                            <div class="block">
                              <el-input v-model="order.deliveryContactPerson" readonly
                              ></el-input>
                            </div>
                          </el-form-item>
                          <el-form-item label="提货联系方式" class="h-elformWrap-2" prop="deliveryContactInformation">
                            <div class="block">
                              <el-input v-model="order.deliveryContactInformation" readonly
                              ></el-input>
                            </div>
                          </el-form-item>-->
                            <el-form-item
                                    :label="receivedTimeName"
                                    class="h-elformWrap-2"
                                    prop="receivedTime">
                                <div class="block">
                                    <el-input v-model="order.receivedTime" readonly></el-input>
                                </div>
                            </el-form-item>


                            <el-form-item prop="kucun" label="库位" v-if="this.order.orderCategory1 == '4' || this.order.orderCategory1 == '26'" class="h-elformWrap-2">
                                <brselect clearable
                                          :disabled="true"
                                          category="order_shouh_kuwei"
                                          :v="order.kucun"
                                          v-model="order.kucun"></brselect>
                            </el-form-item>

                            <el-form-item prop="kucun" label="库位" v-if="this.order.orderCategory1 == '6'" class="h-elformWrap-2">
                                <brselect clearable
                                          :disabled="true"
                                          category="nx_mianfei_kuwei"
                                          :v="order.kucun"
                                          v-model="order.kucun"></brselect>
                            </el-form-item>

                            <el-form-item v-if="(this.order.category1Name == '标准订单'||this.order.category1Name == '特价订单') && this.lkFlag " prop="fileUrl" label="施工图纸"
                                class="fujian" style="display:inline-block; width:600px"  >
                                <brupload
                                    :refid=ywid
                                    reftype="施工图纸"
                                    :showtime="false"
                                >
                                </brupload>
                            </el-form-item>

                            <el-form-item v-if="(this.order.category1Name == '标准订单'||this.order.category1Name == '特价订单') && this.lkFlag" prop="fileUrl" label="施工确认单"
                                          class="h-elformWrap-2">
                                <brupload
                                        :refid=ywid
                                        reftype="NX_SGQRD"
                                        :showtime="false"
                                >
                                </brupload>
                            </el-form-item>

                            <el-form-item label="海尔标准配置" class="h-elformWrap-2" v-if="(this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单') && this.lkFlag" prop="isStandard">
                                <brselect clearable category="haier_standard" :v="order.isStandard"  disabled="true"
                                          v-model="order.isStandard"></brselect>
                            </el-form-item>

                            <el-form-item v-if="(this.order.category1Name == '标准订单'||this.order.category1Name == '特价订单') && this.lkFlag " prop="fileUrl" label="投标参数"
                                          class="h-elformWrap-2">
                                <brupload
                                        :refid=ywid
                                        reftype="NX_TBCS"
                                        :showtime="false"
                                >
                                </brupload>
                            </el-form-item>
                            <el-form-item label="是否战略" class="h-elformWrap-2">
                                <brselect clearable disabled category="is_zhanlue" :v="order.isZl" v-model="order.isZl"></brselect>
                            </el-form-item>
                            <el-form-item label="是否协同收入" class="h-elformWrap-2" v-if="!showXietong" >
                                <brselect clearable category="is_xietong" :v="order.isXietong" v-model="order.isXietong"></brselect>
                            </el-form-item>
                            <el-form-item  prop="fileUrl" label="战略附件"
                                           class="h-elformWrap-2">
                                <brupload
                                        :refid=orderid
                                        reftype="NX_ZLXY"
                                        :showtime="false"
                                >
                                </brupload>
                            </el-form-item>

                            <el-form-item  prop="fileUrl" label="附件"
                                           class="h-elformWrap-2">
                                <brupload
                                        :refid=ywid
                                        reftype="SECOND_ORDER_FJ"
                                        :showtime="false"
                                >
                                </brupload>
                            </el-form-item>

                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->

            <!--------------------------------售后信息--------------->
            <div class="h-pieceIn2" v-if="showshouhouflag">
                <div class="h-pieceTitle2" style="margin-left:10px;">
                    <h1>售后信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form2" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <!--<el-form-item prop="tuihyy" label="退货原因" :rules="[-->
                            <!--{ required: true, message: '请输入退货原因', trigger: 'change'},-->
                            <!--]"  class="h-elformWrap-2">-->
                            <!--<brselect clearable category="tuihuo_yuanyin" :v="order.tuihyy"-->
                            <!--v-model="order.tuihyy"></brselect>-->
                            <!--</el-form-item>-->
                            <el-form-item prop="tuihyydes" label="质量检测描述" class="h-elformWrap-2">
                                <el-input v-model="order.tuihyydes" placeholder="质量检测描述" style="width: 13rem;" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>

            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <div  class="h-table h-mrt30 ljjtablepaddings" style="margin: 20px 20px 0 20px;">
                <div class="h-pieceTitle2 message">
                    <h1 v-if="showshouhouflag"><span v-if="productlist9390.length>0">发货产品信息</span></h1>
                    <h1 v-else>发货产品信息</h1>
                </div>


                <div v-for="obj in companyInfoList">
                    <div v-if="getProductlist(obj.code).length>0">
                        <span style="color: #4a4a4a">{{ obj.name }}</span>
                    <el-form label-position="right" :inline="true" :ref="'form'+obj.code" :model="order"
                             class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
                        <el-form-item label="成本中心" :prop="'costCenter'+obj.code" v-if="showIsFree&&!showIsFreeSh" style="width: 50%;">
                            <el-select v-model="order['costCenter'+obj.code]" style="width: 350px;" disabled
                                       placeholder="--选择--">
                                <el-option v-for="item in getCostList(obj.code)" :key="item.index"
                                           :label="`${item.costCenterCode} : ${item.remark}`"
                                           :value="item.costCenterCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange($event, obj.code)"
                            :data="getProductlist(obj.code)"
                            stripe
                            border
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="30"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#"
                                width="30">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="sapCode"
                                label="订单号"
                                :show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                :show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                label="产品名称"
                                min-width="190"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialName}}
                                </div>
                            </template>
                        </el-table-column>


                        <el-table-column
                                v-if="!chooseFhWay"
                                prop="secondAgentFhWay"
                                label="发货方式"
                                width="150">
                            <template slot-scope="scope">
                                <desselect category="second_agent_fh_way" :des="defaultFhWay"  :v="scope.row.secondAgentFhWay"
                                           v-model="scope.row.secondAgentFhWay"></desselect>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="chooseFhWay"
                                prop="secondAgentFhWay"
                                label="发货方式"
                                width="150">
                            <template slot-scope="scope">
                                <brselect   category="second_agent_fh_way" @input="changeFhWay(scope.row)" :v="scope.row.secondAgentFhWay" v-model="scope.row.secondAgentFhWay" ></brselect>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="hhpt && chooseFhWay"
                                prop="orderCategory1"
                                label="转订单类型"
                                width="150">
                            <template slot-scope="scope">
                                <el-select class="h-tableInput" v-if="scope.row.isZhifa"
                                           @input="changeOrderType($event,scope.row)" v-model="scope.row.orderCategory1" :v="scope.row.orderCategory1" placeholder="请选择">
                                    <el-option label="标准订单" value="2"></el-option>
                                    <el-option label="特价订单" value="11"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
                                width="70">
                            <template slot-scope="scope">
                                <div style="text-align: right;" v-if="scope.row.isSplit != 1">
                                    {{scope.row.proNumber}}
                                </div>
                                <el-input v-if="scope.row.isSplit == 1" v-model="scope.row.proNumber" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="chaidan"
                                prop="splitNumber"
                                label="拆单前数量"
                                :show-overflow-tooltip="true"
                                width="100">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.splitNumber}}
                                </div>
                            </template>
                        </el-table-column>税率/征收率
                        <el-table-column
                                v-if="showRent"
                                :key="Math.random()"
                                prop="cwddh"
                                label="财务订单号"
                                width="140">
                        </el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
                                v-if="!secondAgent && 'secondDingdmainlist' != hideColumn || hhpt"
                                width="70">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.proBenchmarkPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="showOEMflag"
                                :key="Math.random()"
                                prop="cgmll"
                                label="毛利率"
                                width="80">
                            <template slot-scope="scope">
                                {{scope.row.cgmll | numFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="showOEMflag"
                                prop="currencyCode"
                                label="币种"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                :key="Math.random()"
                                prop="specialPrice"
                                label="特价"
                                width="70"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.specialPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                :key="Math.random()"
                                prop="sid"
                                label="特价版本号"
                                min-width="210"
                        >
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                :key="Math.random()"
                                prop="projectName"
                                label="特价项目名称"
                                min-width="180"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.projectName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                :key="Math.random()"
                                prop="proDiscount"
                                label="高/低特价"
                                min-width="110"
                        >
                            <template slot-scope="scope">
                                <div v-if="scope.row.specialPrice <= scope.row.proBenchmarkPrice">低</div>
                                <div v-else>高</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="showSamplePro"
                                :key="Math.random()"
                                prop="discount"
                                label="打折级别"
                                width="150">
                            <template slot-scope="scope">
                                <brselect class="h-tableInput" disabled category="sample_product_discount" :v="scope.row.discount" v-if="!isA33"
                                          v-model="scope.row.discount"/>
                                <brselect class="h-tableInput" disabled category="sample_product_discount_a33" :v="scope.row.discount" v-if="isA33"
                                          v-model="scope.row.discount"/>
                            </template>
                        </el-table-column>

                        <el-table-column
                                v-if="dingzhishowflag && !showService"
                                :key="Math.random()"
                                prop="extraDes"
                                label="定制需求"
                                width="150">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.extraDes}}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                v-if="dingzhishowflag && !showService"
                                :key="Math.random()"
                                prop="extraPrice"
                                label="定制加价"
                                width="110">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.extraPrice}}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="finalPrice"
                                label="成交价"
                                v-if="!secondAgent  && 'secondDingdmainlist' != hideColumn || hhpt"
                                width="80">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.finalPrice}}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="taxRate"
                                label="税率"
                                v-if="order.orderCategory1 == 9"
                                :key="Math.random()"
                                width="110">
                            <template slot-scope="scope">
                                 <el-select class="h-tableInput" :disabled="taskstatus != '0'"
                                           @input="changeTax($event,scope.row)" v-model="scope.row.taxCode" placeholder="请选择" disabled>
                                     <el-option label="0%" value="J0"></el-option>
                                     <el-option label="6%" value="JQ"></el-option>
                                     <el-option label="13%" value="JC"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="jinejjz"
                                label="净价值"
                                v-if="!secondAgent  && 'secondDingdmainlist' != hideColumn || hhpt"
                                width="80">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{ scope.row.jinejjz}}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="totalprice"
                                label="总价"
                                v-if="!secondAgent  && 'secondDingdmainlist' != hideColumn || hhpt"
                                width="80"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;" v-if="scope.row.isSplit != 1">
                                    {{scope.row.totalprice}}
                                </div>
                                <div style="text-align: right;" v-if="scope.row.isSplit == 1">{{ (scope.row.totalprice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice
                                    || scope.row.proBenchmarkPrice || 0)).toFixed(2).toString())}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="note1"
                                label="备注"
                                :show-overflow-tooltip="true"
                                width="110"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.note1}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="hhpt" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" class="h-tableLink h-btn" @click="orderSplit(scope.row,scope.$index)">
                                    拆单
                                </el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                    <div class="jieguo" v-if="!showIsFree && !secondAgent && 'secondDingdmainlist' != hideColumn || hhpt" >
                        <span class="jieguo_label">订单总价</span>
                        <span class="jieguo_value">{{ getOrderName(obj.code).orderPrice }}</span>


                        <span class="jieguo_label">净价值</span>
                        <span class="jieguo_value">{{ getOrderName(obj.code).orderNetWorth }}</span>
                    </div>
                    </div>
                </div>

            </div>
            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <!--退回产品信息-->
            <div v-if="showshouhouflag && productlist2.length>0" class="h-table h-mrt30 "
                 style="margin: 20px 20px 0 20px;">
                <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
                    <h1 class="h1">退货产品信息</h1>
                </div>
                <el-table
                        ref="multipleTable"
                        :data="productlist2"
                        stripe
                        border
                        style="width: 100%">
                    <el-table-column
                            fixed
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="proModelName"
                            label="产品大类"
                            :show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="sapCode"
                            label="订单号"
                            :show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="materialCode"
                            label="产品编码"
                            :show-overflow-tooltip="true"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="materialName"
                            min-width="190"
                            :show-overflow-tooltip="true"
                            label="产品名称">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.materialName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="proNumber"
                            label="订单数量"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.proNumber}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="proBenchmarkPrice"
                            label="基准价"
                            :show-overflow-tooltip="true"
                            v-if="!secondAgent"
                            width="150">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.proBenchmarkPrice}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="currencyCode"
                            label="币种"
                            :show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="finalPrice"
                            label="成交价"
                            :show-overflow-tooltip="true"
                            v-if="!secondAgent"
                            width="150">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.finalPrice}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="totalprice"
                            label="总价"
                            :show-overflow-tooltip="true"
                            v-if="!secondAgent"
                            width="120">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.totalprice}}
                            </div>
                        </template>
                        <template slot-scope="scope">
                            {{ (scope.row.totalprice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice ||
                            scope.row.proBenchmarkPrice || 0)).toString())}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
         <div class="h-table h-mrt30    bbbb" v-if="this.taskstatus == '0'">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">审批意见</h1>
                <el-form :model="spform" label-position="right" :inline="true"
                         class="demo-ruleForm h-formbLine ">
                    <el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:20px" :required="true">
                        <el-input v-model="spform.shpyj" placeholder="请输入"
                        ></el-input>
                    </el-form-item>

                </el-form>
            </div>
        </div>
        <div class="anniu" v-if="this.taskstatus == '0' ">
            <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="saveOrSubmit(0)">返回</el-button>

            <el-button class="el-button h-btn h-bBtn h-bgred el-button--default"
                       @click="saveOrSubmit(2)">驳回
            </el-button>
            <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="saveOrSubmit(1)">通过
            </el-button>
            <el-button class="el-button h-btn el-button--default"
                       @click="viewpress">审批跟踪
            </el-button>
        </div>
        <div class="anniu" v-if="this.taskstatus == '1'">
            <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="saveOrSubmit(0)">返回</el-button>
             <el-button class="el-button h-btn el-button--default"
                       @click="viewpress">审批跟踪
            </el-button>
        </div>






    </div>

</template>

<script>
    import big from 'big.js'
    import ss from '../../api/SystemService'


    export default {
        //     let id = this.$route.query.ywid || this.$route.query.id;
        //
        // let instid = this.$route.query.instid;
        // let taskid = this.$route.query.taskid;
        // let taskstatus = this.$route.query.taskstatus;
        props:["orderid","orderinstid","ordertaskid","ordertaskstatus","hideColumn"],
        filters: {
            numFilter(value) {
                let realVal = ''
                if (value) {
                    // 截取当前数据到小数点后两位
                    realVal = parseFloat(value).toFixed(2) * 100 + '%'
                } else {
                    realVal = '--'
                }
                return realVal
            }
        },
        data() {
            return {
                refid: null,
                regionaddflag:false,
                showRent : false,
                shenqingzuofeiList: [],
                //选中的
                selectedList: [],

                 showSampleHetong: false,
                chaidan:false,
                //作废原因
                zuofeiyy:null,
                chooseOrder9390:[],
                chooseOrder9370:[],
                chooseOrder1D90:[],
                chooseOrder1JC0:[],
                chooseOrder1RK0:[],
                chooseOrder1R60:[],
                chooseOrder9391:[],
                chooseOrder0PN0:[],
                chooseOrder1S00:[],
                chooseOrder1S40:[],
                chooseOrder44U0:[],
                chooseOrder45K0:[],
                priceName: "基准价",
                costList: [],
                costList9390: [],
                costList9370: [],
                costList1D90: [],
                costList1JC0: [],
                costList1RK0: [],
                costList1R60: [],
                costList9391: [],
                costList0PN0: [],
                costList1S00: [],
                costList1S40: [],
                costList44U0: [],
                costList45K0: [],
                isA33: false,
                receivedTimeName: "预计收货日期",
                showIsFree: false,
                showIsFreeSh:false,
                showSamplePro: false,
                showshouhouflag: false,
                showService: false,
                showOEMflag: false,
                hhpt: false,
                isZhifa:false,
                aflag: false,
                instid: null,
                tejieshowflag: false,
                dingzhishowflag: false,
                spform: {
                    ywid: null,
                    taskid: null,
                    taskstatus: null,
                    optflag: null,
                    shpyj: null,
                    shouyiarea: null,
                    isHh:null,
                    secondOrderMainProductList: null,
                },
                showhistory: false,

                //是否能选择发货方式
                chooseFhWay: true,
                //默认发货方式
                defaultFhWay:'',

                qyjlspyj:null,//区域经理审批意见
                 order: {
                    id: null, // 主键
                    orderCategory: null, // 订单类型
                    orderCategory1: null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
                    saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
                    disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                    zCode: null, // 分销渠道编码-子编码
                    customerChannelCode: null, // 客户渠道
                    isStockUp: null, // 是否备货      1：是；0：否
                    orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
                    instid: null, // 流程id
                    tuihyy: null, // 退货原因
                    tuihyydes: null, // 退货原因说明
                    contactName: null, // 联系人名称
                    receivedTime: null, // 预计收货时间
                    soldToCode: null, // 售达方编码
                    soldToName: null, // 售达方名称
                    salesregion: null, // 售达方销售名称
                    soldToAreaCode: null, // 售达方地区编码
                    shipToCode: null, // 送达方编码
                    shipToName: null, // 送达方名称
                    shipToAreaCode: null, // 送达方地区编码
                    invoiceCode: null, // 开票方编码
                    payerCode: null, // 付款方编码
                    currencyCode: null, // 币种编码
                    orderPrice: 0, // 订单总价
                    orderPriceXj: 0, // 订单现金占用
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderPriceXjQk: 0, // 现金欠款
                    orderNetWorth: 0, // 订单净价值
                    poId: null, // PO号
                    areaId: null, // 区域详情表关联id
                    dcCode: null, // 配送中心编码
                    toProvincesCode: null, // 送达省份编码
                    toCityCode: null, // 送达城市编码
                    note: null, // 订单备注
                    postcode: null, // 邮政编码
                    firsttelephone: null, // 第一个电话
                    secondtelephone: null, // 第二电话
                    extraPrice: null, // 定制加价
                    customized: null, // 定制需求
                    sapsended: null, // 是否已提交sap,1-是,0-否
                    toAddress: null, // 收货地址
                    toCompanyname: null, // 送达方公司全称

                    categoryName: null,
                    category1Name: null,
                    saleGrputName: null,
                   deliveryContactPerson:null,
                   deliveryContactInformation:null,
                    fileUrl:[],
                    isXietong:null,
                },
//行项目
                productlist9390: [],
                productlist9370: [],
                productlist1D90: [],
                productlist1JC0: [],
                productlist1RK0: [],
                productlist1R60: [],
                productlist9391: [],
                productlist0PN0: [],
                productlist1S00: [],
                productlist1S40: [],
                productlist44U0: [],
                productlist45K0: [],
                order9390: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order9370: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order1D90: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order1JC0: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order1RK0: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order1R60: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order9391: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order0PN0: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order1S00: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order1S40: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order44U0: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order45K0: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },

                ywid:null,
                //产品list
                productlist1: [],
                productlist2: [],
                gscode: null,

                //用户信贷list
                creditData: [],
                lkFlag:false,
                csFlag:false,
                secondAgent:false,
                //所有公司信息
                companyInfoList: [],
                showXietong: false,
            }
        },
        //页面加载前事件
        created() {
            //是否协同收入
            this.showXietong = this.$store.getters.hasRole("swyl_gndailishang,swyl_gwdailishang,swyl_xiaoshoujl,swyl_xiaoshoujl_wx,swyl_dingdgly,swyl_waixiaogly");
            //所有公司信息
            this.companyInfoList = this.$store.getters.dictlist("company_info");
            //生产所有公司产品变量
            this.companyInfoList.forEach((obj) => {
                //动态生成监听
                this.$watch('productlist'+ obj.code,(newValue, oldValue) => {
                    //计算总金额
                    this['order'+obj.code].orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)

                    //计算总净价值
                    this['order'+obj.code].orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)



                }, { deep: true, immediate: true });

            })
            console.log("this.companyInfoList", this.companyInfoList)

            this.ywid = this.$route.query.ywid || this.$route.query.id;
            if(this.$route.query.ywid || this.$route.query.id){
                this.ywid = this.$route.query.ywid || this.$route.query.id;
            }else{
                this.ywid = this.orderid;
            }
            this.instid = this.orderinstid;
            this.taskstatus = this.ordertaskstatus;
            this.spform.ywid = this.orderid;
            console.log(this.orderid)
             this.spform.taskid = this.ordertaskid;
            this.getOrder(this.orderid,this.ordertaskid);

            //判断能否显示价格信息
            //如果不是内部用户 并且 agentLevel=2  一级经销商审批的时候也不看
            if(this._user.usertype!='0' && (this._user.agentLevel ==2 || this._user.agentLevel ==1)){
                //判断是否是分销商（二级经销商）
                this.secondAgent = true;
            }



        },
        computed: {
            xsqyStr() {
                if (this.order.category1Name) {
                    if(this.order.category2Name){
                        return this.order.categoryName + "/" + this.order.category1Name + "/" + this.order.category2Name
                    }else {
                        return this.order.categoryName + "/" + this.order.category1Name
                    }
                }
                return this.order.categoryName
            },
            xszzStr() {
                return "(" + this.gscode + ")" + this.$store.getters.dictname('YLSalesOrganization_agent', this.gscode);
            },

            total() {
                return this.rows.map(
                    row => row.purchaseCount * row.price).reduce(
                    (acc, cur) => (parseFloat(cur) + acc), 0)
            }
        },

        watch: {
            productlist1: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {

                    //计算总净价值
                    this.order.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                },
            },



        },

        methods: {
            handleData2(array, key){
                const groups = {}
                array.forEach(function (o) {
                    const group = o[key]
                    groups[group] = groups[group] || []
                    groups[group].push(o)
                })

                //console.log(groups)--图1
                //{收入主题:[{},{}...],住院主题:[{},{},,]}

                return Object.values(groups)
            },
            changeTax(data,row){
                if(data=="J0"){
                    row.taxRate="1";
                }else if(data=="JQ"){
                    row.taxRate="1.06";
                }else if(data=="JC"){
                    row.taxRate="1.13";
                }
            },
            changeOrderType(data,row){
                if(data=="标准订单"){
                    row.orderCategory1="2";
                }else if(data=="特价订单"){
                    row.orderCategory1="11";
                }
            },
            changeFhWay(row){
                if(this.hhpt){
                    if(row.secondAgentFhWay == "2"){
                        row.isZhifa = true;
                    }else {
                        row.isZhifa = false;
                    }
                }
            },
            isUpload(v) {
                this.testID ="test" +  this.$route.query.ywid;
                console.log(v)
                if (v.length > 0) {
                    //this.order.fileUrl = v[0].saveurl;
                    let arrnew = []
                    v.forEach(e => {
                        arrnew.push(e.saveurl)
                    })
                    console.log(arrnew)
                    this.order.fileUrl = arrnew
                    console.log(this.order.fileUrl)
                }else{
                    this.order.fileUrl =''
                }
            },




            getOrder(id,taskid) {
                this.refid = id
                ss.SecondOrderMainService.selectSecondOrderById(id,taskid).then(rd => {
                    this.regionaddflag = rd.obj.regionadd;
                    console.log("111111111",this.regionaddflag);
                    console.log("22222",rd.obj);
                    // console.log(rd.obj.products, '订单列表')
                    this.shenqingzuofeiList = rd.obj.products;
                     if(this.shenqingzuofeiList.length>0){
                        this.zuofeiyy = this.shenqingzuofeiList[0].deleteReason;
                    }else{
                        this.zuofeiyy = "";
                    }

                    // this.productlist1 = rd.obj.products
                    _.assign(this.order, rd.obj)
                    if(this.order.soldToCode=='A33'){
                        this.isA33 =true;
                    }else{
                        this.isA33 =false;
                    }



                    let type = this.order.orderCategory1;
                    //是否能选 发货方式 服务订单只能海尔直发
                    if(type=='9'){
                        this.chooseFhWay =false;
                        this.defaultFhWay="2";
                    }

                    //存在行项目
                    if (rd.obj.products && rd.obj.products.length > 0) {
                        rd.obj.products.forEach((obj) => {
                            if (obj) {
                                this.gscode = obj.gscode;
                                obj.splitNumber = obj.proNumber;
                                //这里赋值一个id,用来标记产品拆单
                                obj.splitId = this.$util.getUuid();
                                this.addProject(obj)
                                ss.waixiao.isLk(obj.materialCode).then(rd => {
                                    this.lkFlag = rd.msg;
                                    console.log("lkFlag",this.lkFlag)
                                    //如果是冷库产品,则在新增时需先生成一个虚拟的预测单号用于绑定附件,点击预测单提交时更新绑定真实的预测单编号
                                })
                            }
                        })
                    }


                    if(rd.obj.isStandard == 2){
                        this.csFlag = true;
                    }
                    if(rd.obj.hhptCode != null && rd.obj.hhptCode != ""){
                        this.hhpt = true;
                        this.spform.hhType = "1"
                        this.companyInfoList.forEach((val) => {
                            if(val.code == '1S00' || val.code == '1S40'){
                                val.name = rd.obj.hhptNameA
                            }
                        })
                        this.order.orderCategory1 = type;
                        //是否能选 发货方式 服务订单只能海尔直发
                        if(type=='11'){
                            rd.obj.products.forEach((obj) => {
                                if (obj) {
                                    obj.orderCategory1 = type;
                                    obj.secondAgentFhWay = "2";
                                }
                            })
                            this.chooseFhWay =false;
                            this.defaultFhWay="2";
                        }
                    }
                })


            },
            addProject(obj) {
                //区域经理审批意见
                if(!this.qyjlspyj){
                    this.qyjlspyj = obj.yidishpyj||null;
                }

                // console.log("获取到的是南通单list",obj)
                if(!this.order['costCenter' + obj.gscode]){
                    this.order['costCenter' + obj.gscode] = obj.costCenter||null;
                }
                if (obj.specialPrice) {
                    this.tejieshowflag = true;
                }
                if (obj.extraPrice) {
                    this.dingzhishowflag = true;
                }
                // if (obj.shouyiarea) {
                //     this.spform.shouyiarea = obj.shouyiarea
                // }
                this.order.orderPrice = obj.totalprice; // 订单现金占用
                this.order.orderPriceXj = obj.jinexj; // 订单现金占用
                this.order.orderPriceXd = obj.jinexd; // 订单信贷占用
                this.order.orderPriceXjQk = obj.jinexjqk; // 订单欠款
                this.order.orderNetWorth = new big(obj.totalprice || 0).div(1.13).toFixed(2);
                // this.order.costCenter = obj.costCenter;
                if (obj.orderztype == '发货单') {
                    // this.productlist1.push(obj);
                    this['productlist' + obj.gscode].push(obj);
                } else {
                    this.productlist2.push(obj);
                }
            },
            viewpress(r) {
                this.showhistory = true;
            },
            backtolist() {
                this.$router.go(-1);
            },
            saveOrSubmit(v) {

                //合并所有订单list
                this.spform.secondOrderMainProductList = [];
                this.companyInfoList.forEach((obj) => {
                    this.spform.secondOrderMainProductList = this.spform.secondOrderMainProductList.concat(this['chooseOrder'+obj.code]);
                })

                // console.log('我在这儿呀', v);
                if(v != '0' && (!this.selectedList || this.selectedList.length < 1)){
                    this.$msg.msge("请先勾选要处理的产品行!");
                    return;
                }
                if (v == '2') {
                    this.spform.optflag = '驳回'
                    if (!this.spform.shpyj) {
                        this.$msg.msge("驳回必须输入审批意见！");
                        return;
                    }
                } else if (v == '1') {
                    //检查是否选择发货方式
                    for(var i=0;i<this.spform.secondOrderMainProductList.length;i++) {
                        if (!this.spform.secondOrderMainProductList[i].secondAgentFhWay) {
                            this.$msg.msge("请选择订单号:" + this.spform.secondOrderMainProductList[i].sapCode + "的发货方式!");
                            return false;
                        }
                    }
                    this.spform.optflag = '通过'

                    //厚宏校验拆单
                    if(this.hhpt){
                        const mergeList = this.handleData2(this.spform.secondOrderMainProductList,"splitId");
                        console.log(mergeList);
                        for(var i=0;i<mergeList.length;i++) {
                            const products = mergeList[i];
                            var proNumber = 0;
                            for(var j=0;j<products.length;j++) {
                                proNumber = Number(proNumber)+Number(products[j].proNumber);
                            }
                            console.log(proNumber);
                            console.log(products[0].splitNumber);
                            if(proNumber != products[0].splitNumber){
                                this.$msg.msge("产品:" + products[0].materialCode + "的拆单总数量与拆单前产品数量不一致,请检查!");
                                return false;
                            }
                        }
                    }

                } else {
                    //点击详情进来的
                    if (this.$route.query.f == '1') {
                        this.$router.back();
                        return;
                    }
                    this.$emit('refreshSelf',{close:true,refresh:false});
                    return;
                }
                var confirmMsg = this.selectedList[0].status == '71' && v == '1' ? "通过后会直接作废订单,确认通过?" : "确认提交?";
                this.$msg.confirm(confirmMsg, () => {
                    this.submitForm();
                })
            },
            submitForm() {

                ss.SecondOrderMainService.secondLevelShpsaveOrSubmit(this.spform).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        if (this.$route.query.f == '1') {
                            this.$router.back();
                            return;
                        }
                        this.$emit('refreshSelf',{close:true,refresh:true});
                        return;
                    })
                })
            },
            handleSelectionChange(v,code){
                this['chooseOrder'+code] = v;
                this.selectedList = v;
            },
            getProductlist(code){
                console.log("productlist"+code,this[`${'productlist' + code}`].length)
                return this['productlist' + code];
            },
            //根据公司编码返回OrderName
            getOrderName(code){
                 return this['order' + code];
            },
            //根据公司编码返回costList
            getCostList(code){
                 return this['costList' + code];
            },
            orderSplit(row,index){
                if(row.proNumber <= 1){
                    this.$msg.msge("当前行项目产品数量为1,不可拆分!");
                    return;
                }
                this.chaidan = true;
                console.log(row,index)
                row.isSplit = 1;//标记拆单
                //这里先拆出来一个,需要拆分用户自己在改
                row.proNumber =  row.proNumber-1;
                var product = JSON.parse(JSON.stringify(row));//深度拷贝
                product.proNumber = 1;
                product.sapCode = "HHNCD00001";
                product.chaifen = true;
                product.id = this.$util.getUuid();
                this['productlist' + row.gscode].splice(index+1,0,product)
            }
        }
    }

</script>


<style scoped>
    .anniu {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.3rem;
    }


    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
    }

    .jieguo .jieguo_label {
        width: 1.5rem;
        text-align: right;
        background-color: #ebf5ff;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo .jieguo_value {
        width: 20%;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0px 8px;
    }

    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .hang {
        padding: 20px 0;
        background-color: white;
    }

    .bbbb {
        background-color: white;
        margin: 0 20px;

    }
</style>
<style>
    .showflowDialogcls .el-dialog__body{
        padding-top: 0px!important;
    }
    .h-formbLine .el-form-item__content .addredclass .el-input__inner{
        color: #ff7875;
    }
    .h-formbLine .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }

    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }

    .ljjtablepaddings .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .fujian{
        width:600px;
        display: inline;
    }
    .fujian /deep/.el-form-item__label{ width: 21% !important}
    .fujian /deep/.el-upload-list{width:500px}
</style>
